import {AccountMin, ExternalWhoAmIResponse} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function login(account: AccountMin, token: string) {
  return await platformedClient.externalRequest("post", `/region/{region}/external_api/accounts/{account_id}/login`, {
    path: {region: account.region, account_id: account.account_id},
    header: {Authorization: `Bearer ${token}`},
  });
}

export async function logout(account: AccountMin) {
  await platformedClient.externalRequest("post", `/region/{region}/external_api/accounts/{account_id}/logout`, {
    path: {region: account.region, account_id: account.account_id},
  });
  await invalidateQueries([q.external.filter()]);
}

export async function whoAmI(account: AccountMin): Promise<ExternalWhoAmIResponse> {
  return await platformedClient.externalRequest("get", `/region/{region}/external_api/accounts/{account_id}/whoami`, {
    path: {region: account.region, account_id: account.account_id},
  });
}

export async function changeLanguage(account: AccountMin, languageCode: string) {
  await platformedClient.externalRequest("post", `/region/{region}/external_api/accounts/{account_id}/language`, {
    path: {region: account.region, account_id: account.account_id},
    body: languageCode,
  });
  await invalidateQueries([q.external.auth.whoAmI.filter()]);
}
